/* MM Read More - Læs mere / Læs mindre
   Kollapser lange tekstblokke og tilføjer en toggle-knap.
   Indholdet forbliver i DOM'en (SEO/AI-crawlere ser fuld tekst).

   Konfiguration (valgfri, sæt før dette script loader):
   window.MMReadMoreConfig = { maxHeight: 400, selectors: [...] };

   Manuel styring:
   - <div class="mm-read-more" data-mm-rm-height="200">...</div>  -> tvinger funktionen på vilkårligt indhold
   - class "mm-rm-off" på element eller forælder -> deaktiverer
*/
(function () {
  'use strict';

  var DEFAULTS = {
    selectors: [
      '.mm-read-more',
      '.product__description',
      '.rich-text__text',
      '[id^="shopify-section-"][id*="custom_liquid"] .page-width',
      '[id^="shopify-section-"][id*="custom-liquid"] .page-width'
    ],
    maxHeight: 320,
    buffer: 80, // kollaps kun hvis indholdet er mindst buffer px højere end maxHeight
    labels: {
      da: { more: 'Læs mere', less: 'Læs mindre' },
      sv: { more: 'Läs mer', less: 'Visa mindre' },
      en: { more: 'Read more', less: 'Read less' }
    }
  };

  var cfg = Object.assign({}, DEFAULTS, window.MMReadMoreConfig || {});
  var lang = (document.documentElement.lang || 'da').slice(0, 2).toLowerCase();
  var labels = cfg.labels[lang] || cfg.labels.da;

  function initEl(el) {
    if (!el || el.dataset.mmRmInit) return;
    if (el.closest('.mm-rm-off')) return;
    // Undgå nested read-more (fx .mm-read-more inde i en custom liquid-sektion)
    var ancestor = el.parentElement && el.parentElement.closest('.mm-rm');
    if (ancestor) return;
    if (el.querySelector('.mm-rm')) return;
    if (el.offsetParent === null) return; // skjult - prøv igen senere (fx quick view)

    var maxH = parseInt(el.getAttribute('data-mm-rm-height') || cfg.maxHeight, 10);
    if (el.scrollHeight <= maxH + cfg.buffer) return;

    el.dataset.mmRmInit = '1';
    el.classList.add('mm-rm', 'mm-rm--collapsed');
    el.style.setProperty('--mm-rm-height', maxH + 'px');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mm-rm__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = labels.more;

    // Knappen skal følge sidens indholdsbredde:
    // Hvis selve elementet er en .page-width (custom liquid), wrappes knappen i en .page-width,
    // så den flugter med resten af sidens indhold i stedet for viewportens kant.
    if (el.classList.contains('page-width')) {
      var wrap = document.createElement('div');
      wrap.className = 'page-width mm-rm__toggle-wrap';
      if (el.classList.contains('page-width--full-width')) wrap.classList.add('page-width--full-width');
      if (el.classList.contains('page-width--inner')) wrap.classList.add('page-width--inner');
      wrap.appendChild(btn);
      el.insertAdjacentElement('afterend', wrap);
    } else {
      el.insertAdjacentElement('afterend', btn);
    }

    btn.addEventListener('click', function () {
      var collapsed = el.classList.contains('mm-rm--collapsed');
      if (collapsed) {
        // Udvid
        el.style.maxHeight = el.scrollHeight + 'px';
        el.classList.remove('mm-rm--collapsed');
        btn.textContent = labels.less;
        btn.setAttribute('aria-expanded', 'true');
        window.setTimeout(function () {
          if (!el.classList.contains('mm-rm--collapsed')) el.style.maxHeight = 'none';
        }, 450);
      } else {
        // Kollaps
        el.style.maxHeight = el.scrollHeight + 'px';
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            el.style.maxHeight = '';
            el.classList.add('mm-rm--collapsed');
          });
        });
        btn.textContent = labels.more;
        btn.setAttribute('aria-expanded', 'false');
        if (el.getBoundingClientRect().top < 0) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  function initAll(root) {
    root = root && root.querySelectorAll ? root : document;
    cfg.selectors.forEach(function (sel) {
      try {
        root.querySelectorAll(sel).forEach(initEl);
      } catch (e) { /* ugyldig selector - ignorér */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Fang indhold der først får højde efter fonts/billeder er loadet
  window.addEventListener('load', function () { initAll(); });
  // Theme editor: re-init når en sektion genindlæses
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.MMReadMore = { init: initAll };
})();
